import axios from "axios";
import {
  getProducts,
  GetProductsByCategory,
} from "../../Services/MainServices";

export const FETCH_CATEGORY_PRODUCTS_REQUEST =
  "FETCH_CATEGORY_PRODUCTS_REQUEST";
export const FETCH_CATEGORY_PRODUCTS_SUCCESS =
  "FETCH_CATEGORY_PRODUCTS_SUCCESS";
export const FETCH_CATEGORY_PRODUCTS_FAILURE =
  "FETCH_CATEGORY_PRODUCTS_FAILURE";

/**
 * Thunk: fetchCategoryProducts
 * - Takes `categorySlug` from the route (e.g. "Kids")
 * - Reads the rest of the filters from `state.filters`
 * - Builds a query string matching your backend API
 * - Dispatches success/failure
 */
export const fetchCategoryProducts =
  (filters) => async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const isAuthenticated = auth?.isAuthenticated;
      dispatch({ type: FETCH_CATEGORY_PRODUCTS_REQUEST });

      const {
        categories = [],
        subCategory = "",
        sizes = [],
        colors = [],
        tags = [],
        price = { min: 0, max: 0 },
        searchTerm = "",
      } = filters;

      const params = {};

      if (categories.length > 0) params["category"] = categories;
      if (subCategory) params["sub_category"] = subCategory;
      if (sizes.length > 0) params["sizes"] = sizes.join(",");
      if (colors.length > 0) params["colors"] = colors.join(",");
      if (tags.length > 0) params["tags"] = tags.join(",");
      if (
        isAuthenticated &&
        price.min !== null &&
        price.max !== null &&
        price.min != 0 &&
        price.max != 0
      ) {
        // params["price[min]"] = price.min;
        // params["price[max]"] = price.max;
        params["min_price"] = price.min;
        params["max_price"] = price.max;
      }
      if (searchTerm) params["search_term"] = searchTerm;

      // 4) Call the backend
      const response = await getProducts(params);

      // 5) Status checks and payload extraction
      if (
        response &&
        response.status === 200 &&
        response.data &&
        (Array.isArray(response.data.products) ||
          Array.isArray(response.data.data))
      ) {
        // Prefer products, fallback to data
        const products = response.data.products || response.data.data || [];
        dispatch({
          type: FETCH_CATEGORY_PRODUCTS_SUCCESS,
          payload: products,
        });
      } else {
        throw new Error("Unexpected Response Format");
      }
    } catch (error) {
      dispatch({
        type: FETCH_CATEGORY_PRODUCTS_FAILURE,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong while fetching products",
      });
    }
  };
